<template>
	<span class="text-ai"
		><span v-if="speaker.department_id && speaker.title" class="s-title">{{ speaker.title }} </span
		><span v-if="!speaker.department_id && speaker.first_name" class="s-name">{{ speaker.first_name }} </span
		>{{ speaker.last_name }}
		<span v-if="speaker.department_id" class="s-department"
			>({{ departments.find(d => d.id === speaker.department_id).name }})</span
		>
	</span>
</template>

<style lang="scss" scoped>
@import '@/assets/variables';

.s-title {
	font-weight: 300;
	color: $neutral-400;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
	props: {
		speaker: {
			type: Object,
			required: true,
		},
	},
	computed: {
		...mapState(['departments']),
	},
	created() {
		this.$store.dispatch('loadDepartments')
	},
}
</script>
